import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export const DAYS = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
const hh = (h) => `${String(h).padStart(2, "0")}:00`;

export function BestTimes() {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/analytics/best-times", { params: { days: 90 } }).then((r) => setD(r.data)); }, []);
  if (!d) return null;
  const max = Math.max(1, ...d.grid.flat());
  const hours = Array.from({ length: 24 }, (_, i) => i);
  return (
    <div className="bg-white border rounded-xl p-5" data-testid="best-times-heatmap">
      <div className="flex flex-wrap items-baseline justify-between gap-2 mb-3">
        <h3 className="font-bold">Best send times <span className="text-xs font-normal text-slate-500">· opens by day and hour, Irish time, last 90 days</span></h3>
        <span className="text-sm" data-testid="best-time-summary">{d.best ? <>Best: <b>{DAYS[d.best.weekday]} {hh(d.best.hour)}</b> ({d.best.opens} opens)</> : <span className="text-slate-500">Not enough opens yet. You need at least 5 ({d.total} so far).</span>}</span>
      </div>
      <div className="overflow-x-auto">
        <div className="inline-grid gap-[3px]" style={{ gridTemplateColumns: `40px repeat(24, minmax(22px, 1fr))` }}>
          <div />{hours.map((h) => <div key={h} className="text-[9px] text-slate-400 text-center">{h % 3 === 0 ? h : ""}</div>)}
          {d.grid.map((row, di) => [
            <div key={`l${di}`} className="text-[11px] text-slate-500 pr-1 self-center">{DAYS[di]}</div>,
            ...row.map((n, h) => (
              <div key={`${di}-${h}`} title={`${DAYS[di]} ${hh(h)}: ${n} opens`} data-testid={`heat-${di}-${h}`}
                className={`h-6 rounded-[4px] ${d.best && d.best.weekday === di && d.best.hour === h ? "ring-2 ring-orange-500" : ""}`}
                style={{ background: n ? `rgba(37,99,235,${0.12 + 0.88 * (n / max)})` : "#f1f5f9" }} />
            )),
          ])}
        </div>
      </div>
    </div>
  );
}
